export default "__VITE_ASSET__DEzkw3mA__"